import React from 'react';
import { PageTitleZoneNext } from '../../../../components/page-title-zone';

export function AttendanceImportTitlezone() {
  return <PageTitleZoneNext isLoading={false} entityName="Fremmøde" title="Indlæs fremmøde" />;
}
